import axios from '../../utils/axiosConfig';

export default function AuthService() {
  const getUser = () => axios.get(`/api/v1/influencers/influencers/get_user.json`)
    .then(({ data: userData }) => {

      if (userData
        && Object.keys(userData).length > 0
        && Object.getPrototypeOf(userData) === Object.prototype) {
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('userLoginDate', Date());
        return userData;
      }
      console.log('userData is empty');
      return null;
    })
    .catch((error) => {
      console.log(error);
    });


  const loginUser = (values) => axios.post('/api/v1/influencers/users/sign_in', {
    'user_login': values
  }).then(({ data }) => data);


  const signUpUser = (data) => axios.post('/api/v1/influencers/users', {
    user: data
  }).then(({ data }) => data);

  return {
    getUser,
    loginUser,
    signUpUser
  };
}
